import { getToken, removeToken } from '@/utils/auth'

const state = {
  userInfo: null,
  loginTan: false,
  loginRulesNotifyVisible: false
}

const getters = {
  isLoggedIn(state) {
    const uuid = localStorage.getItem('uuid')
    return !!state.userInfo || !!uuid || !!getToken()
  },
  userInfo(state) {
    return state.userInfo
  },
  loginTan(state) {
    return state.loginTan
  },
  loginRulesNotifyVisible(state) {
    return state.loginRulesNotifyVisible
  }
}

const mutations = {
  userInfo(state, value) {
    state.userInfo = value
  },
  loginTan(state, value) {
    state.loginTan = value
  },
  SET_LOGIN_RULES_NOTIFY(state, value) {
    state.loginRulesNotifyVisible = !!value
  }
}

const actions = {
  /** 拉取当前用户信息并写入 store */
  async fetchUserInfo({ commit }) {
    const { userInfo: userInfoApi } = await import('@/api/index')
    const res = await userInfoApi({})
    const profile = res && res.data !== undefined ? res.data : null
    commit('userInfo', profile)
    return profile
  },

  /** 调用后端「是否登录」接口（需自行根据返回结构处理） */
  async checkLogin() {
    const { userhaslogin } = await import('@/api/index')
    return userhaslogin({})
  },

  /** 应用启动：有 token 则尝试同步用户信息 */
  async initAuth({ dispatch, commit }) {
    const hasSession = !!getToken() || !!localStorage.getItem('uuid')
    if (!hasSession) {
      commit('userInfo', null)
      return null
    }
    try {
      return await dispatch('fetchUserInfo')
    } catch (e) {
      commit('userInfo', null)
      return null
    }
  },

  /** 主动退出：清 token、清用户信息、关闭登录弹层 */
  logout({ commit }) {
    removeToken()
    localStorage.removeItem('uuid')
    localStorage.removeItem('salt')
    commit('userInfo', null)
    commit('loginTan', false)
    commit('SET_LOGIN_RULES_NOTIFY', false)
  },

  /** 401 / 会话失效：清状态并弹出登录 */
  onUnauthorized({ commit }) {
    removeToken()
    localStorage.removeItem('uuid')
    localStorage.removeItem('salt')
    commit('userInfo', null)
    commit('loginTan', true)
    commit('SET_LOGIN_RULES_NOTIFY', false)
  },

  setLoginDialog({ commit }, visible) {
    commit('loginTan', !!visible)
  },

  setLoginRulesNotify({ commit }, visible) {
    commit('SET_LOGIN_RULES_NOTIFY', !!visible)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
